//Maaz A : 06-02-2023 : BT-95890 -  Breeze - Breeze Login - For First time users - Start
import { logoutSession, loginSession, createAccount, userDetails, changePassword, sendOTP, verifyOTP, registerTOTP, registerMPIN, setGuestRegDetail, validateGuestOTP, changeNewPassword, sendMpinOTP, generateQR, forgotUserId, dpDetailsEDIS, interopConfiguration, } from "../../apis";
import { LOGIN, USER_REGISTER, TOTP, OTP, GUEST_LOGIN, GET_DP_DETAILS_SUCCESS, GET_DP_DETAILS_FAILURE, GET_INTEROP_CONFIG_DETAILS_SUCCESS, GET_INTEROP_CONFIG_DETAILS_FAILURE, GET_DEVICE_INFO } from "../actionTypes";
import config from '../../config.json';
import { API_CODES, API_ERRORS, API_SOURCE, APPLICATION_TYPE, LOGIN_ERROR, LOCAL_STORAGE_KEYS, NETWORK_RESPONSE_STATUS } from "../../utils/global_variables";
import { deepClone, getDecryptLocalStorage, setEncryptLocalStorage } from "../../utils/global_functions";
import { changeMpin, deleteTOTP, verifyTOTP } from "../../apis/authentication";
import { _setUserProfile } from "../../controllers";
import { v4 as uuidv4 } from 'uuid';
export const updateIsSignUp = (payload) => {
    return { type: LOGIN.UPDATE_SIGNUP, payload };
};


export const userRegister = (objPayload = {}) => async (dispatch, getState) => {
    try {
        const objResp = await createAccount(objPayload);
        dispatch(userRegisterSuccess(objResp.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(userRegisterFailure(error?.response?.data));
        } else {
            dispatch(userRegisterFailure({}));
        }
    }
};


export const userRegisterSuccess = (payload) => {
    return { type: USER_REGISTER.USER_REGISTER_SUCCESS, payload };
};

export const userRegisterFailure = (payload) => {
    return { type: USER_REGISTER.USER_REGISTER_FAILURE, payload };
};

// BT-95890 -Mahesh S -  first time user login - code added for auth service down - start
export const authServiceDown = (payload) => {
    return { type: LOGIN.AUTH_SERVICE_DOWN, payload };
};
// BT-95890 -Mahesh S -  first time user login - code added for auth service down - end


export const updateIsLoading = (payload) => {
    return { type: LOGIN.UPDATE_IS_LOADING, payload };
};

export const updateMpinEnabled = (payload) => {
    return { type: LOGIN.UPDATE_MPIN_ENABLED, payload };
};
export const updateForgotMpin = (payload) => {
    return { type: LOGIN.UPDATE_FORGOT_MPIN, payload };
};
export const updateResetMpin = (payload) => {
    return { type: LOGIN.UPDATE_RESET_MPIN, payload };
};
export const userLogin = (userId = '', password = '', loginType = '', secondAuthType = '', secondAuthValue = '') => async (dispatch, getState) => {
    try {
        // let alias = getState().auth.aliasId;
        dispatch(updateIsLoading(true));
        const payload = {
            "user_id": userId,
            "login_type": loginType,
            "password": password,
            "second_auth": secondAuthValue,
            "api_key": config.Wave.ApiKey,
            "source": API_SOURCE.BREEZE,
            "version": API_SOURCE.VERSION,
            "buildVersion": config.buildVersion

        };
        if (loginType === 'MPIN_TDES') {
            payload[`second_auth_type`] = secondAuthType;
        } else if (loginType === 'PASSWORD_TDES' || loginType === 'TOKEN') {
            payload[`second_auth_type`] = secondAuthType;
        } else { }
        dispatch(updateUserId(userId));

        let objResp = await loginSession(payload);

        let appInfo = !getState()?.appInfo?.appInfo.length;

        if (Array.isArray(appInfo) && !appInfo?.length) {
            throw new Error(LOGIN_ERROR.APP_INFO_FAILURE);
        }
        // objResp = {...objResp, data: {...objResp.data, data: {...objResp.data.data, user_id: "HELLO"}}}
        // // dispatch(updateIsLoading(false));
        if ((objResp?.data?.data?.user_id !== userId) && (objResp?.data?.data?.alias_id !== userId)) {
            throw new Error(LOGIN_ERROR.INVALID_USER);
        }

        dispatch(updateUserId(objResp?.data?.data?.user_id));

        // Added condition here for edge case when alias_id is coming "" for some users
        if (objResp?.data?.data?.alias_id && objResp?.data?.data?.user_id !== objResp?.data?.data?.alias_id) {
            dispatch(updateAliasId(objResp?.data?.data?.alias_id));
        }


        dispatch(userLoginSuccess(objResp.data));
        if (objResp?.data?.data?.login_time) {
            if (objResp?.data?.data?.mpin_enabled) {
                setEncryptLocalStorage(LOCAL_STORAGE_KEYS.MPIN_ENABLE, 'true');
            } else {
                setEncryptLocalStorage(LOCAL_STORAGE_KEYS.MPIN_ENABLE, 'false');
            }
        } else { }
        return Promise.resolve(objResp);
    } catch (error) {
        // console?.error(error?.response);
        dispatch(updateIsLoading(false));
        if (error.message === LOGIN_ERROR.APP_INFO_FAILURE) {
            dispatch(userLoginFailure({ status: 'error', code: 'e-101', message: 'Please try again after sometime', errors: 'e-14', data: undefined }));
        } else if (error.message === LOGIN_ERROR.INVALID_USER) {
            dispatch(userLoginFailure({ status: 'error', code: 'e-101', message: 'User IDs do not match', errors: 'e-14', data: undefined }));
        }
        else if (error?.response?.status === NETWORK_RESPONSE_STATUS.BAD_REQUEST && (error?.response?.data?.code === API_ERRORS.ECODE_INCORRECT_TOTP || error?.response?.data?.code === API_ERRORS.ECODE_INCORRECT_OTP || error?.response?.data?.code === API_CODES.ECODE_SERVER_ERROR)) {
            const objInitLoginSession = deepClone(getState()?.auth?.objUserDetails);
            dispatch(userLoginFailure({ ...error?.response.data, data: objInitLoginSession?.result }));
        }
        else if (error?.response?.status === NETWORK_RESPONSE_STATUS.BAD_REQUEST && error?.response?.data?.code) {
            dispatch(userLoginFailure(error?.response?.data));
        }
        else if (error?.response?.status === NETWORK_RESPONSE_STATUS.AUTH_SERVICE_DOWN) { // BT-95890 - LOGIN - code added for auth service down
            dispatch(authServiceDown(true));
        }
        else if (error?.code === API_ERRORS.ECODE_NETWORK_ERROR) {
            dispatch(userLoginFailure(error));
        }
        else {
            dispatch(userLoginFailure({}));
        }
        return Promise.reject(error);
    }
};

export const updateUserId = (payload) => {
    payload = payload?.toUpperCase();
    return { type: LOGIN.UPDATE_USER_ID, payload };
};

export const userLoginSuccess = (payload) => {
    return { type: LOGIN.USER_LOGIN_SUCCESS, payload };
};

export const userLoginFailure = (payload) => {
    return { type: LOGIN.USER_LOGIN_FAILURE, payload };
};
// ---BT-113521_SrikanthRao_17-07-2023
export const updateCft = (payload) => {
    return { type: LOGIN.UPDATE_CFT, payload };
};

export const updatePassword = (userId = '', oldPassword = '', newPassword = '', type = 'TDES') => async (dispatch) => {
    try {
        const payload = {
            "user_id": userId,
            "old_password": oldPassword,
            "new_password": newPassword,
            "api_key": config.Wave.ApiKey,
            "type": type,
            "source": API_SOURCE.BREEZE,

        };
        dispatch(updateIsLoading(true));
        const objResp = await changePassword(payload);
        dispatch(updateIsLoading(false));
        dispatch(updatePasswordSuccess(objResp.data));
    } catch (error) {
        dispatch(updateIsLoading(false));
        console.log(error.message);
        if (error?.response?.data) {
            dispatch(updatePasswordFailure(error.response.data));
        } else {
            dispatch(updatePasswordFailure({}));
        }
    }
};

export const updatePasswordSuccess = (payload) => {
    return { type: LOGIN.UPDATE_PASSWORD_SUCCESS, payload };
};

export const updatePasswordFailure = (payload) => {
    return { type: LOGIN.UPDATE_PASSWORD_FAILURE, payload };
};


export const updateAliasId = (payload) => {
    return { type: LOGIN.ALIAS_ID, payload };
};



export const getUserDetials = (userId = '') => async (dispatch) => {
    try {
        const objResp = await userDetails(userId);
        dispatch(getUserDetialsSuccess(objResp.data));
        return objResp;
    } catch (error) {
        console.log(error.message);
        if (error?.response?.data) {
            dispatch(getUserDetialsFailure(error?.response?.data));
        } else {
            dispatch(getUserDetialsFailure({}));
        }
        return error;
    }
};





export const getUserDetialsSuccess = (payload) => {
    return { type: USER_REGISTER.USER_DETAILS_SUCCESS, payload };
};

export const getUserDetialsFailure = (payload) => {
    return { type: USER_REGISTER.USER_DETAILS_FAILURE, payload };
};

export const userMPINRegister = (userId = '', otpToken = '', mpin = '') => async (dispatch, getState) => {
    try {
        dispatch(updateIsLoading(true));
        const payload = {
            "user_id": userId,
            "api_key": config.Wave.ApiKey,
            "source": API_SOURCE.BREEZE,
            "otp": otpToken,
            "mpin": mpin,
        };
        const objResp = await registerMPIN(payload);
        dispatch(userMPINRegisterSuccess(objResp.data));
    } catch (error) {
        console.error(error);
        dispatch(updateIsLoading(false));
        if (error?.response?.data) {
            dispatch(userMPINRegisterFailure(error?.response?.data));
        } else {
            dispatch(userMPINRegisterFailure({}));
        }
    }
};


export const userMPINRegisterSuccess = (payload) => {
    return { type: USER_REGISTER.USER_REGISTER_MPIN_SUCCESS, payload };
};

export const userMPINRegisterFailure = (payload) => {
    return { type: USER_REGISTER.USER_REGISTER_MPIN_FAILURE, payload };
};


export const userChangeMPIN = (userId = '', oldMpin = '', newMpin = '', navigator = {}, udid = '', localHost) => async (dispatch, getState) => {
    try {
        dispatch(updateIsLoading(true));
        const payload = {
            "user_id": userId,
            "api_key": config.Wave.ApiKey,
            "source": API_SOURCE.BREEZE,
            "old_mpin": oldMpin,
            "new_mpin": newMpin,
            "deviceinfo": {
                "UDID": udid,
                "DeviceModel": navigator.platform,
                "DeviceSerialNo": "",
                "DeviceManufacturer": navigator.vendor,
                "DevicePlatform": "web",
                "DevicePlatformVer": navigator.userAgent,
                "Longitude": "",
                "Latitude": "",
                "AppName": "Breeze",
                "AppVersion": navigator.appVersion,
                "AppVersionCode": "2000000",
                "AppPackageName": "Breeze",
                "FCMRegKey": localHost,
                "IP": ""
            }
        };
        const objResp = await changeMpin(payload);
        // dispatch(updateIsLoading(false));
        dispatch(userChangeMPINSuccess(objResp?.data));
    } catch (error) {
        if (error?.response?.data) {
            dispatch(updateIsLoading(false));
            console.error(error.message);
            dispatch(userChangeMPINFailure(error?.response?.data));
        } else {
            dispatch(userChangeMPINFailure({}));
        }
    }
};


export const userChangeMPINSuccess = (payload) => {
    return { type: USER_REGISTER.USER_CHANGE_MPIN_SUCCESS, payload };
};

export const userChangeMPINFailure = (payload) => {
    return { type: USER_REGISTER.USER_CHANGE_MPIN_FAILURE, payload };
};

export const userSentOTP = (user = '') => async (dispatch, getState) => {
    try {
        // Ajitesh 06-09-2024 removing loader which shows text as "Verifying OTP" when user is navigating to OTP page before any OTP is entered
        dispatch(updateIsLoading(true)); // Ajitesh 07-08-2024 Adds correct loader to fix issue of loader stuck in loop on OTP screen
        let userId = '';
        let isUserPresent = getState()?.auth?.objLoginSession?.data?.user_id;

        if (user) {
            if (isUserPresent) {
                userId = isUserPresent;
            } else {
                userId = user;
            }
        }
        const payload = {
            "user_id": userId,
            "api_key": config.Wave.ApiKey,
            "source": API_SOURCE.BREEZE,
        };
        const objResp = await sendOTP(payload);
        dispatch(userSentOTPSuccess(objResp.data));
        dispatch(updateIsLoading(false)); // Ajitesh 07-08-2024 Adds correct loader to fix issue of loader stuck in loop on OTP screen
    } catch (error) {
        console.error(error?.message);
        if (error?.response?.data) {
            dispatch(updateIsLoading(false));
            dispatch(userSentOTPFailure(error?.response?.data));
        } else {
            dispatch(updateIsLoading(false));
            dispatch(userSentOTPFailure({}));
        }
    }
};


export const userSentOTPSuccess = (payload) => {
    return { type: OTP.USER_SENT_OTP_SUCCESS, payload };
};

export const userSentOTPFailure = (payload) => {
    return { type: OTP.USER_SENT_OTP_FAILURE, payload };
};

export const userSentOTPLoading = (payload) => {
    return { type: OTP.USER_SENT_OTP_LOADING, payload };
};



//Mahesh S : 13-02-2023 : BT-97226 -  Breeze - Subsequent Login - Start
export const updateNewPassword = (userId = '', newPassword = '', userMobile = '', otpToken = '', type = 'TDES') => async (dispatch) => {
    try {
        const payload = {
            "user_id": userId,
            "mobileNo": userMobile,
            "new_password": newPassword,
            'otp': otpToken,
            "type": type,
            "api_key": config.Wave.ApiKey,
            "source": API_SOURCE.BREEZE,

        };
        const objResp = await changeNewPassword(payload);
        dispatch(updateNewPasswordSuccess(objResp.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(updateNewPasswordFailure(error.response.data));
        } else {
            dispatch(updateNewPasswordFailure({}));
        }
    }
};

export const updateNewPasswordSuccess = (payload) => {
    return { type: LOGIN.UPDATE_NEW_PASSWORD_SUCCESS, payload };
};

export const updateNewPasswordFailure = (payload) => {
    return { type: LOGIN.UPDATE_NEW_PASSWORD_FAILURE, payload };
};

export const userSentOTPMpin = (userId = '') => async (dispatch, getState) => {
    try {
        dispatch(updateIsLoading(true));
        const payload = {
            "user_id": userId,
            "api_key": config.Wave.ApiKey,
            "source": API_SOURCE.BREEZE,
        };
        const objResp = await sendMpinOTP(payload);
        dispatch(userSentOTPMpinSuccess(objResp.data));
        dispatch(updateIsLoading(false));
    } catch (error) {
        console.error(error.message);
        dispatch(updateIsLoading(false));
        if (error?.response?.data) {
            dispatch(userSentOTPMpinFailure(error?.response?.data));
        } else {
            dispatch(userSentOTPMpinFailure({}));
        }
    }
};

export const userSentOTPMpinSuccess = (payload) => {
    return { type: OTP.USER_SENT_OTP_MPIN_SUCCESS, payload };
};

export const userSentOTPMpinFailure = (payload) => {
    return { type: OTP.USER_SENT_OTP_MPIN_FAILURE, payload };
};

//Mahesh S : 13-02-2023 : BT-97226 -  Breeze - Subsequent Login - Ends

export const userVerifyOTP = (user = '', userOtp = '', userMobile = '') => async (dispatch, getState) => {
    try {

        let userId = '';
        let isUserPresent = getState()?.auth?.objLoginSession?.data?.user_id;

        if (user) {
            if (isUserPresent) {
                userId = isUserPresent;
            } else {
                userId = user;
            }
        }

        dispatch(updateIsLoading(true));
        const payload = {
            "user_id": userId,
            "otp": userOtp,
            "mobileNo": userMobile,
            "api_key": config.Wave.ApiKey,
            "source": API_SOURCE.BREEZE,
        };
        const objResp = await verifyOTP(payload);
        dispatch(userVerifyOTPSuccess(objResp.data));
        // dispatch(updateIsLoading(false));
        return Promise.resolve(objResp);
    } catch (error) {
        console.error(error.message);
        dispatch(updateIsLoading(false));
        if (error?.response?.data) {
            dispatch(userVerifyOTPFailure(error?.response?.data));
        } else {
            dispatch(userVerifyOTPFailure({}));
        }
        return Promise.reject(error);
    }
};


export const userVerifyOTPSuccess = (payload) => {
    return { type: OTP.USER_VERIFY_OTP_SUCCESS, payload };
};

export const userVerifyOTPFailure = (payload) => {
    return { type: OTP.USER_VERIFY_OTP_FAILURE, payload };
};



export const userRegisterTOTP = (userId = '', userOtp = '', userMobile = '') => async (dispatch, getState) => {
    try {
        dispatch(updateIsLoading(true));
        const payload = {
            "user_id": userId,
            "otp": userOtp,
            "mobileNo": userMobile,
            "api_key": config.Wave.ApiKey,
            "source": API_SOURCE.BREEZE,
            "app_name": APPLICATION_TYPE
        };
        const objResp = await registerTOTP(payload);
        dispatch(userRegisterTOTPSuccess(objResp.data));
        // dispatch(updateIsLoading(false));
    } catch (error) {
        console.error(error.message);
        dispatch(updateIsLoading(false));
        if (error?.response?.data) {
            dispatch(userRegisterTOTPFailure(error?.response?.data));
        } else {
            dispatch(userRegisterTOTPFailure({}));
        }
    }
};


export const userRegisterTOTPSuccess = (payload) => {
    return { type: TOTP.USER_REGISTER_TOTP_SUCCESS, payload };
};

export const userRegisterTOTPFailure = (payload) => {
    return { type: TOTP.USER_REGISTER_TOTP_FAILURE, payload };
};

export const QRExpire = (payload) => {
    return { type: LOGIN.QR_EXPIRE, payload };
};

/*Mahesh S  : 25-04-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - Start */
export const userGenerateQR = () => async (dispatch, getState) => {
    try {
        const payload = {
            "api_key": config.Wave.ApiKey,
            "source": API_SOURCE.BREEZE,
            "version": "2.0.0",
        };
        const objResp = await generateQR(payload);
        dispatch(userGenerateQRSuccess(objResp.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(userGenerateQRFailure(error?.response?.data));
        } else {
            dispatch(userGenerateQRFailure({}));
        }
    }
};

export const userGenerateQRSuccess = (payload) => {
    return { type: LOGIN.USER_GENERATE_QR_CODE_SUCCESS, payload };
};

export const userGenerateQRFailure = (payload) => {
    return { type: LOGIN.USER_GENERATE_QR_CODE_FAILURE, payload };
};

export const userLoginQR = (qrToken = '', type = '') => async (dispatch, getState) => {
    try {
        const payload = {
            "login_type": type,
            "password": qrToken,
            "api_key": config.Wave.ApiKey,
            "source": API_SOURCE.BREEZE,

        };
        const objResp = await loginSession(payload, true);

        if (objResp?.status && objResp?.data?.response?.data?.code === API_CODES?.ECODE_QR_EXPIRED) {
            dispatch(QRExpire(true));
        } else {
            dispatch(userLoginSuccess(objResp.data));
            dispatch(updateUserId(objResp?.data?.data?.user_id));
            if (objResp?.data?.data?.login_time) {
                if (objResp?.data?.data?.mpin_enabled) {
                    setEncryptLocalStorage(LOCAL_STORAGE_KEYS.MPIN_ENABLE, "true");
                } else {
                    setEncryptLocalStorage(LOCAL_STORAGE_KEYS.MPIN_ENABLE, "false");
                }
            } else { }
        }

    } catch (error) {
        console.error(error.message);
    }
};

/*Mahesh S  : 25-04-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - End */

/* Abhijeet V Created Guest login flow apis starts here */
export const setGuestRegDetailApi = (userMobile = '', navigator = {}) => async (dispatch, getState) => {
    try {
        const udid = uuidv4();
        const payload = {
            "Type": 2,
            "deviceType": "T",
            "email": "",
            "groupId": "",
            "mobile": userMobile,
            "pluginData": {

                "DeviceModel": navigator.platform,
                "DeviceManufacturer": navigator.vendor,
                "DevicePlatform": "web",
                "DevicePlatformVer": navigator.userAgent,
                "AppName": "Breeze",
                "AppVersion": navigator.appVersion,
                "AppVersionCode": "2000000",
                "AppPackageName": "Breeze",
                "DeviceSerialNo": "",
                "FCMRegKey": window.location.host,
                "IP": "",
                "Latitude": "",
                "Longitude": "",
                "UDID": udid,
            },
            "reqType": 1,
            "templateId": config.TenantId,
            "userId": userMobile,
            "userType": "G"
        };
        //BT-120013 : Bug Fixing : Guest Login : Manasa B : 20/10/2023 - Start


        const objResp = await setGuestRegDetail(payload);

        if (objResp?.data?.data?.trial_expired) {
            const error = {
                "status": "error",
                "code": "e-101",
                "message": 'Your Guest Trial Period Expired.'
            };
            dispatch(updateIsLoading(false));
            dispatch(setGuestRegDetailFailure(error));
        } else {
            dispatch(updateIsLoading(false));
            if (objResp.data?.data?.access_token) {
                dispatch(updateUserId(userMobile));
                //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
                let newObj = { ...objResp?.data, data: { ...objResp?.data?.data, exchanges: ["NSE_EQ", "BSE_EQ"] } };
                dispatch(userLoginSuccess(newObj));
                //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
            }
            else {
                dispatch(userSentOTPSuccess(objResp.data));
                dispatch(setGuestRegDetailSuccess(objResp.data));
            }
        }


    } catch (error) {
        console.error(error.message);
        dispatch(updateIsLoading(false));
        if (error?.response?.data) {
            dispatch(setGuestRegDetailFailure(error?.response?.data));
        } else {
            dispatch(setGuestRegDetailFailure({}));
        }
    }
};

export const setGuestRegDetailSuccess = (payload) => {
    return { type: GUEST_LOGIN.SET_GUEST_REG_DETAILS_SUCCESS, payload };
};

export const setGuestRegDetailFailure = (payload) => {
    return { type: GUEST_LOGIN.SET_GUEST_REG_DETAILS_FAILURE, payload };
};

export const userVerifyTOTP = (userTotp = '') => async (dispatch, getState) => {
    try {
        dispatch(updateIsLoading(true));
        const payload = {
            second_auth: userTotp
        };
        const objResp = await verifyTOTP(payload);
        dispatch(updateIsLoading(false));
        return Promise.resolve(objResp);
    }
    catch (error) {
        console.error(error.message);
        dispatch(updateIsLoading(false));
        return Promise.reject(error);
    }
};

// Ajitesh 07-08-2024 Action to disable TOTP which calls delete version of registertotp api
export const userDisableTOTP = () => async (dispatch) => {
    try {
        const objResp = await deleteTOTP();
        return Promise.resolve(objResp);
    }
    catch (error) {
        console.error(error.message);
        return Promise.reject(error);
    }
};

export const validateGuestOTPApi = (userMobile = '', OTP = '', navigator = {}, udid = '', localHost = '') => async (dispatch, getState) => {
    try {
        // dispatch validate Guest OTP Api
        dispatch(updateIsLoading(true));

        const payload = {
            "OTP": OTP,
            "Type": 2,
            "deviceType": "T",
            "email": "",
            "groupId": "",
            "mobile": userMobile,
            "pluginData": {
                "DeviceModel": navigator.platform,
                "DeviceManufacturer": navigator.vendor,
                "DevicePlatform": "web",
                "DevicePlatformVer": navigator.userAgent,
                "AppName": "Breeze",
                "AppVersion": navigator.appVersion,
                "AppVersionCode": "2000000",
                "AppPackageName": "Breeze",
                "DeviceSerialNo": "",
                "FCMRegKey": localHost,
                "IP": "",
                "Latitude": "",
                "Longitude": "",
                "UDID": udid,
            },
            "reqType": 3,
            "templateId": "1524",
            "userId": userMobile,
            "userType": "G"
        };
        const objResp = await validateGuestOTP(payload);
        dispatch(updateIsLoading(false));

        if (objResp?.data?.data?.reg_date && objResp?.data?.data?.trial_expired) {
            const error = {
                "status": "error",
                "code": "e-101",
                "message": 'Your Guest Trial Period Expired.'
            };
            dispatch(validateGuestOTPFailure(error));
            dispatch(userSentOTPFailure(error));
        } else {
            //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            let newObj = { ...objResp?.data, data: { ...objResp?.data?.data, exchanges: ["NSE_EQ", "BSE_EQ"] } };
            //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
            dispatch(validateGuestOTPSuccess(newObj));
            dispatch(updateUserId(userMobile));
            dispatch(userLoginSuccess(newObj));
        }
        return objResp;
    } catch (error) {
        console.error(error.message);
        dispatch(updateIsLoading(false));
        if (error?.response?.data) {
            dispatch(validateGuestOTPFailure(error?.response?.data));
            dispatch(userSentOTPFailure(error?.response?.data));
        } else {
            dispatch(validateGuestOTPFailure({}));
        }
        return error;
    }
};

export const validateGuestOTPSuccess = (payload) => {
    return { type: GUEST_LOGIN.VALIDATE_GUEST_OTP_SUCCESS, payload };
};

export const validateGuestOTPFailure = (payload) => {
    return { type: GUEST_LOGIN.VALIDATE_GUEST_OTP_FAILURE, payload };
};

/* Abhijeet V Created Guest login flow apis ends here */
export const resetAllAuthData = () => async (dispatch) => {
    dispatch(userRegisterFailure({}));
    dispatch(updateUserId(''));
    dispatch(userLoginFailure({}));
    dispatch(updatePasswordFailure({}));
    dispatch(getUserDetialsFailure({}));
    dispatch(userMPINRegisterFailure({}));
    dispatch(userSentOTPFailure({}));
    dispatch(userVerifyOTPFailure({}));
    dispatch(userRegisterTOTPFailure({}));
    dispatch(setGuestRegDetailSuccess({}));
    dispatch(setGuestRegDetailFailure({}));
    dispatch(validateGuestOTPSuccess({}));
    dispatch(validateGuestOTPFailure({}));
    dispatch(getForgotUserIDFailure({}));
    dispatch(userGenerateQRFailure({}));
    dispatch(authServiceDown(false));
    dispatch(updateIsLoading(false));
};

const clearLocalStorage = (objLoginSession) => {
    if (objLoginSession) {
        const userDetails = JSON.parse(getDecryptLocalStorage(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${objLoginSession?.data?.user_id}`));
        setEncryptLocalStorage(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${objLoginSession?.data?.user_id}`, JSON.stringify({ ...userDetails, data: {} }));
    }
    else { }
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.CHART_URL_ATTRIBUTES);
};


export const userLogout = () => async (dispatch, getState) => {
    const objLoginSession = deepClone(getState().auth?.objLoginSession);
    try {
        const objResp = await logoutSession();
        dispatch(userLogoutSuccess(objResp.data));
        //Ameersa N: to delete the indexedDB database
        indexedDB.deleteDatabase('axios-cache');
        // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACCEPTED_NOTICES_ID);
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.REJECTED_NOTICES_ID);
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.CHECKBOX_NOTICES_ID);
        // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --End
        clearLocalStorage(objLoginSession);
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.OPENED_WATCHLIST);
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACTIVE_WATCHLIST);
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.GUEST_TOAST);
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.PUBLIC_KEY);
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.SERVER_KEY);
        localStorage?.removeItem(LOCAL_STORAGE_KEYS.HEADER);
        return Promise.resolve();
    } catch (error) {
        console.log(error);
        dispatch(userLogoutFailure([]));
        clearLocalStorage();
        return Promise.reject();
    }

};


export const userLogoutSuccess = (payload) => {
    return { type: LOGIN.USER_LOGOUT_SUCCESS, payload };
};

export const userLogoutFailure = (payload) => {
    return { type: LOGIN.USER_LOGOUT_FAILURE, payload };
};


/* Shuaib.P  SAT-BT-109047 Start  */

export const getUserProfile = () => async (dispatch) => {
    const objResp = await _setUserProfile();
    if (objResp?.status) {
        dispatch(getUserProfileSuccess(objResp?.data));
    } else {
        dispatch(getUserProfileFailure([]));
    }
};
/* Shuaib.P  SAT-BT-109047 End  */




export const getUserProfileSuccess = (payload) => {
    return { type: LOGIN.USER_PROFILE_SUCCESS, payload };
};

export const getUserProfileFailure = (payload) => {
    return { type: LOGIN.USER_PROFILE_FAILURE, payload };
};

export const userForgotUserId = (panNo = '') => async (dispatch) => {
    try {
        dispatch(updateIsLoading(true));
        const payload = {
            "panNum": panNo,
            "api_key": config.Wave.ApiKey,
        };
        const objResp = await forgotUserId(payload);
        dispatch(getForgotUserIDSuccess(objResp?.data));
        dispatch(updateIsLoading(false));
    } catch (error) {
        console.error(error.message);
        dispatch(updateIsLoading(false));
        if (error?.response?.data) {
            dispatch(getForgotUserIDFailure(error?.response?.data));
        } else {
            dispatch(getForgotUserIDFailure({}));
        }
    }
};

export const getForgotUserIDSuccess = (payload) => {
    return { type: LOGIN.FORGOT_USER_ID_SUCCESS, payload };
};

export const getForgotUserIDFailure = (payload) => {
    return { type: LOGIN.FORGOT_USER_ID_FAILURE, payload };
};

export const userSwitch = (activeSession) => async (dispatch) => {
    try {
        dispatch(userLoginSuccess(activeSession));
    } catch (error) {
        console.error(error.message);

    }
};

// Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - Start
export const getDPDetailsEDIS = () => async (dispatch) => {
    const objResp = await dpDetailsEDIS();
    if (objResp.status) {
        dispatch(getDPDetailsSuccess(objResp?.data));
    }
    else {
        dispatch(getDPDetailsFailure({}));
    }
};

export const getDPDetailsSuccess = (payload) => {
    return { type: GET_DP_DETAILS_SUCCESS, payload };
};

export const getDPDetailsFailure = (payload) => {
    return { type: GET_DP_DETAILS_FAILURE, payload };
};

export const getInteropConfigurationDetails = () => async (dispatch) => {
    try {
        const objResp = await interopConfiguration();
        if (objResp.status) {
            dispatch(getInteropConfigurationDetailsSuccess(objResp.data.data));
        }
        else {
            dispatch(getInteropConfigurationDetailsFailure({}));
        }
    } catch (error) {
        console.log(error);
    }
};

export const getInteropConfigurationDetailsSuccess = (payload) => {
    return { type: GET_INTEROP_CONFIG_DETAILS_SUCCESS, payload };
};

export const getInteropConfigurationDetailsFailure = (payload) => {
    return { type: GET_INTEROP_CONFIG_DETAILS_FAILURE, payload };
};
// Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - End
export const getDeviceInfo = (payload) => async (dispatch) => {
    dispatch({ type: GET_DEVICE_INFO, payload });
};